import { getPathFromPageId } from 'helpers/getPathFromPageId'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { goTo } from 'route-history'
import { useShallow } from 'zustand/shallow'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const useUpdateUrlWithRequiredSearchParams = (): void => {
  const { pathname, search } = useLocation()
  const { leadId, cohort, currentPageId } = useZustandStore(
    useShallow((state) => ({
      leadId: state.lead?.id || '',
      cohort: state.lead?.cohort || state.initialCohort,
      currentPageId: state.currentPageId,
    })),
  )
  const { language } = useZustandSessionStore(
    useShallow((state) => ({
      language: state.language,
    })),
  )

  useEffect(() => {
    if (!currentPageId) return

    const targetPath = getPathFromPageId({
      pageId: currentPageId,
      cohort,
      uuid: leadId,
      language,
      currentSearch: search,
    })

    const isPathNew = targetPath !== `${pathname}${search}`

    isPathNew && goTo(targetPath)
  }, [cohort, currentPageId, pathname, search, leadId, language])
}
